// Copyright (C) 2021 TANNER AG

import React from "react";
import { compose } from "recompose";
import withConnectionStatus from "../hocs/withConnectionStatus";
import withGeneralTranslations from "../hocs/withGeneralTranslations";
import withLocalization from "../hocs/withLocalization";
import withErrorState from "../hocs/withErrorState";
import { withStyles } from "@material-ui/core/styles";
import { sharedComponentStyles } from "../screens/Component";
import { pad } from "../utils/helper";
import EMobilityTocTopic from "../emobility/EMobilityTocTopic";
import EMobilityTocChapter from "../emobility/EMobilityTocChapter";
import { NAVIGATION_HEIGHT } from "../layouts/Navigation";
import { HEADER_HEIGHT } from "../layouts/Header";
import Heading6 from "../styleguide/Heading6";
import routes from "../emobility/routes";
import withTSTopics from "../hocs/withTSTopics";

const styles = (theme) => ({
    root: {
        position: "sticky",
        top: HEADER_HEIGHT + NAVIGATION_HEIGHT,
        padding: "16px 0 8px 32px",
    },
    heading: {
        marginBottom: 16,
    },
});

const TransportSolutionsToc = ({ classes, tSTopics, chapter }) => {
    return (
        <div className={classes.root}>
            <Heading6 className={classes.heading}>TRANSPORT SOLUTIONS</Heading6>
            {tSTopics &&
                tSTopics
                    .filter((currentTopic) => currentTopic.active && !currentTopic.banner)
                    .map((currentTopic) => (
                        <EMobilityTocTopic
                            key={currentTopic.id}
                            title={currentTopic.title}
                            number={pad(currentTopic.order || 0, 2)}
                            open={chapter.tSTopic.order === currentTopic.order}
                            to={`${routes.transportSolutions}/${currentTopic.slug}`}
                        >
                            {currentTopic.tsChapters &&
                                currentTopic.tsChapters.map((currentChapter) => (
                                    <EMobilityTocChapter
                                        key={currentChapter.id}
                                        number={`${currentTopic.order}.${currentChapter.order}`}
                                        title={currentChapter.title}
                                        selected={chapter.order === currentChapter.order}
                                        to={`${routes.transportSolutions}/${currentTopic.slug}/${currentChapter.slug}`}
                                    />
                                ))}
                        </EMobilityTocTopic>
                    ))}
        </div>
    );
};

export default compose(
    withConnectionStatus,
    withGeneralTranslations,
    withLocalization,
    withErrorState,
    withStyles(sharedComponentStyles),
    withStyles(styles),
    withTSTopics()
)(TransportSolutionsToc);



// WEBPACK FOOTER //
// ./src/transportsolutions/TransportSolutionsToc.js